module.exports = __webpack_public_path__ + "img/bg.a4b5b5ef.png";